import { css } from 'aphrodite';
import {
	Dialog,
	DialogPopup,
	DialogHeader,
	DialogTitle,
	DialogBody,
	DialogFooter,
} from '../../../components-v2/Dialog';
import { Button } from '../../../components-v2/Button';
import { THEME } from '../../../components-v2/Theme/theme';
import { styleSheet } from './styles/DeleteAutomationDialogStyles';

interface DeleteAutomationDialogProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isDeleting: boolean;
	automationName: string;
}

export function DeleteAutomationDialog({
	isOpen,
	onClose,
	onConfirm,
	isDeleting,
	automationName,
}: DeleteAutomationDialogProps) {
	return (
		<Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
			<DialogPopup styles={[styleSheet.popup]}>
				<DialogHeader>
					<DialogTitle>Delete Automation?</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p className={css(styleSheet.description)}>
						This will permanently delete <strong>{automationName}</strong> and all of its steps. This action cannot be
						undone.
					</p>
					<div className={css(styleSheet.warningBox)}>
						<svg width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
							<path
								d='M8 1L15 14H1L8 1Z'
								stroke={THEME.colors.danger.main}
								strokeWidth='1.5'
								strokeLinecap='round'
								strokeLinejoin='round'
								fill='none'
							/>
							<path d='M8 6v3' stroke={THEME.colors.danger.main} strokeWidth='1.5' strokeLinecap='round' />
							<circle cx='8' cy='11.5' r='0.75' fill={THEME.colors.danger.main} />
						</svg>
						<span>Deleted automations cannot be recovered.</span>
					</div>
				</DialogBody>
				<DialogFooter styles={[styleSheet.actions]}>
					<Button variant='outline' onClick={onClose} disabled={isDeleting}>
						Cancel
					</Button>
					<Button variant='destructive' onClick={onConfirm} isLoading={isDeleting}>
						Delete Automation
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
}
